import { useQueryGetAllBots } from "@apis:bot/bot";
import { useUser } from "@libs:react-query-auth";
import { useBotSelectionStore } from "@stores:bot-selection";

export const useBotSelection = () => {
  const user = useUser().data;
  const userEmail = user?.email;
  const {
    selectedBotId,
    setSelectedBot,
    userEmail: userEmailPersisting,
  } = useBotSelectionStore();
  const { data } = useQueryGetAllBots(true);

  const selectBotId = (botId: string) => {
    if (userEmail && botId) {
      setSelectedBot(botId, userEmail);
    }
  };

  const getSelectedBot = () => {
    if (!userEmail) {
      return null;
    }

    if (userEmailPersisting !== userEmail) {
      return null;
    }

    if (selectedBotId) {
      return data?.find((bot) => bot.id === selectedBotId) || null;
    }
    return null;
  };

  return {
    selectBotId,
    getSelectedBot,
  };
};
